import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useParams } from 'react-router-dom';
import API from 'config/ApiConfig';

export default function DeleteSiswaForm({ onDelete }) {
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [error, setError] = useState(null);
  const [isDeleting, setIsDeleting] = useState(false);
  const [siswaDetails, setSiswaDetails] = useState(null);
  const [tentorId, setTentorId] = useState('');
  const [tentorDetails, setTentorDetails] = useState('');
  const { siswaId } = useParams();
  const API_BASE_URL = API.API_ADMIN + '/siswa';
  const JWT_TOKEN = localStorage.getItem('authToken'); // Ganti dengan token yang valid

  function getAuthHeaders() {
    return {
      'Authorization': `Bearer ${JWT_TOKEN}`,
      'Content-Type': 'application/json',
    };
  }
  const fetchDataTentor = async () => {
    if (!tentorId) return; // Jika tentorId tidak ada, hentikan fungsi
    try {
      const response = await fetch(API.API_ADMIN + `/tentor/${tentorId}`, {
        headers: getAuthHeaders(),
      });
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      const data = await response.json();
      setTentorDetails(data);
    } catch (err) {
      console.error('Error fetching tentor details:', err);
      setError('Failed to fetch tentor details. Please try again.');
    }
  };

  const fetchSiswaDetails = async () => {
    try {
      const response = await fetch(`${API_BASE_URL}/${siswaId}`, {
        headers: getAuthHeaders(),
      });
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      const data = await response.json();
      setSiswaDetails(data);
      setTentorId(data.tentor_id);
    } catch (error) {
      console.error('Error fetching siswa details:', error);
      setError('Failed to fetch user details. Please try again.');
    }
  };

  useEffect(() => {
    if (siswaId) {
      fetchSiswaDetails();
    }
  }, [siswaId]);

  useEffect(() => {
    if (tentorId) {
      fetchDataTentor();
    }
  }, [tentorId]);

  const handleDelete = async () => {
    setIsDeleting(true);
    try {
      const response = await fetch(`${API_BASE_URL}/${siswaId}`, {
        method: 'DELETE',
        headers: getAuthHeaders(),
      });
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      // Handle successful deletion
      console.log('Siswa deleted successfully');
      if (onDelete) onDelete(); // Optional: Callback on success
      setShowConfirmation(false);
      window.location.href = '/admin/siswa'; // Redirect to user list or any other page
    } catch (error) {
      console.error('Error deleting siswa:', error);
      setError('Failed to delete user. Please try again.');
    } finally {
      setIsDeleting(false);
    }
  };

  const handleCancel = () => {
    setShowConfirmation(false);
    window.location.href = "/admin/siswa";
  };

  return (
    <div>
      <h3 className="font-bold uppercase text-lg text-blueGray-700 align-center m-4">Delete Siswa</h3>
      {error && <p className="text-red-500 text-xs">{error}</p>}
      {siswaDetails && !showConfirmation && (
        <div className="mb-4">
          <p><strong>Nama:</strong> {siswaDetails.nama}</p>
          <p><strong>TTL:</strong> {siswaDetails.ttl}</p>
          <p><strong>Telepon:</strong> {siswaDetails.telepon}</p>
          <p><strong>Nama Orang Tua:</strong> {siswaDetails.nama_orangtua}</p>
          <p><strong>Nama Sekolah:</strong> {siswaDetails.nama_sekolah}</p>
          <p><strong>Kelas:</strong> {siswaDetails.kelas}</p>
          <p><strong>Alamat:</strong> {siswaDetails.alamat}</p>
          <p><strong>Tentor:</strong> {tentorDetails.nama ? tentorDetails.nama : "Belum ada"}</p>
          <button
            type="button"
            className="bg-red-500 text-white active:bg-red-600 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none m-4 ease-linear transition-all duration-150"
            onClick={() => setShowConfirmation(true)}
          >
            Delete Siswa
          </button>
          <button
            type="button"
            className="bg-lightBlue-500 text-white active:bg-lightBlue-600 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none m-4 ease-linear transition-all duration-150"
            onClick={handleCancel}
          >
            Cancel
          </button>
        </div>
      )}
      {showConfirmation && (
        <div>
          <p>Are you sure you want to delete this Siswa?</p>
          <button
            type="button"
            className="bg-red-500 text-white active:bg-red-600 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none m-4 ease-linear transition-all duration-150"
            onClick={handleDelete}
            disabled={isDeleting}
          >
            {isDeleting ? 'Deleting...' : 'Confirm Delete'}
          </button>
          <button
            type="button"
            className="bg-lightBlue-500 text-white active:bg-lightBlue-600 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none m-4 ease-linear transition-all duration-150"
            onClick={handleCancel}
          >
            Cancel
          </button>
        </div>
      )}
    </div>
  );
}

DeleteSiswaForm.propTypes = {
  siswaId: PropTypes.string.isRequired,
  onDelete: PropTypes.func,
};
